<app-stat-group [items]="stats()" />
